export const TRASNPORTER_DATA_COLUMNS = [
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MODULE",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "VEHICLE NO",
    accessor: "Vehicle_No",
    width : 1
  },
  {
    Header: "LR NO",
    accessor: "FLEETX_LR_No",
    width : 1
  },
  {
    Header: "CUSTOMER",
    accessor: "Customer",
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "CONTAINER NO",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
  },
  {
    Header: "CONSIGNEE",
    accessor: "Consignee",
    width : 1
  },
  {
    Header: "CONSIGNOR NAME",
    accessor: "Consignee_name",
    width : 1
  },
  {
    Header: "CLEARANCE",
    accessor: "Clearance",
    width : 1
  },
  {
    Header: "EMPTY YARD",
    accessor: "Empty_yard",
    width : 1
  },
  {
    Header: "MOVEMENT TYPE",
    accessor: "Movement_type",
    width : 1
  },
  {
    Header: "SEAL NO",
    accessor: "Seal_No",
    width : 1
  },
  {
    Header: "DRIVER NO",
    accessor: "Driver_No",
    width : 1
  },
  {
    Header: "PICKUP LOCATION",
    accessor: "Pick_up_Location",
    width : 1
  },
];